<template>
    <jet-form-section @submitted="updateRoute">
        <template #title>
            Admin routes
        </template>

        <template #description>
            Instellen zichtbaarheid routes
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <jet-input id="route_all" name="route[]" type="radio" v-model="form.routes" value="all" :checked="form.routes == 'all'"/>
                <jet-label for="route_all" value="Toon alle routes"  class=" inline ml-5"/><br>
                <jet-input id="route_simple" name="route[]" type="radio" v-model="form.routes" value="simple" :checked="form.routes == 'simple'"/>
                <jet-label for="route_simple" value="Toon enkel routes gebaseerd op mijn rechten"  class=" inline ml-5"/>
                <jet-input-error :message="form.errors.routes" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetLabel from '@/Jetstream/Label.vue'

export default {
    components: {
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
    },props:[
        'settings',
    ],
    data() {
        return {
            form: this.$inertia.form({
                routes: this.settings.route ?? null
            }),
        }
    },

    methods: {
        updateRoute() {
            this.form.put(route('settings.routes'), {
                errorBag: 'updateRoute',
                preserveScroll: true,
            })
        },
    },
}
</script>
